/* eslint-disable @next/next/no-img-element */
import { EXPCONFIG_FAST } from "@/constants/point";
import { EXPOSURE_RECORD, sendClickTrack } from "@/tracks/25630";
import "./titleItem.scss";

export interface TitleProps {
  type: number;
  icon: string;
  title: string;
  content: string;
  time: string;
  num: number;
  showDot: boolean;
  msgId: string;
  orderId: string;
  promoId: string;
}

interface Props {
  data: TitleProps;
  onClick: (type: number, title: string) => void;
}

const TitleItem = ({ data, onClick }: Props) => {
  const { type, icon, msgId, orderId, promoId, title, content, time, num, showDot = false } = data;
  const jsonParam = {
    msgType: title as any,
    msgNum: String(num),
    msgId: msgId,
    orderId: orderId || "",
    promId: promoId || "",
  };

  const handleClick = () => {
    onClick(type, title);
    sendClickTrack.Message_List_MsgList(jsonParam);
  };

  const formatMessageNum = (num: number) => {
    return num >= 100 ? "99+" : num > 0 ? num : "";
  };

  return (
    <div
      className="item cursor"
      onClick={handleClick}
      exptag={"exp|" + EXPOSURE_RECORD.Message_List_MsgListExpo}
      data-exptag-config={EXPCONFIG_FAST}
      data-exptag-json-param={JSON.stringify(jsonParam)}
    >
      <img src={icon} alt={title} />
      <div className="container">
        <div className="top-conent">
          <span className="item-title">{title}</span>
          <span className="time">{time}</span>
        </div>
        <div className="bottom-content">
          <span className={`content ${!!num && "width-limit"}`}>{content}</span>
          {showDot && !!num && <span className="dot" />}
          {!showDot && !!num && (
            <div className="num">
              <span>{formatMessageNum(num)}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TitleItem;
